// Mock data for Hollywood Fame Tour website

export const mockBookings = [
  { name: 'Sarah M.', location: 'New York', partySize: 6, timeAgo: '2 minutes ago' },
  { name: 'James L.', location: 'London', partySize: 4, timeAgo: '5 minutes ago' },
  { name: 'Maria G.', location: 'Miami', partySize: 8, timeAgo: '8 minutes ago' },
  { name: 'David K.', location: 'Chicago', partySize: 5, timeAgo: '12 minutes ago' },
  { name: 'Emma R.', location: 'Toronto', partySize: 4, timeAgo: '15 minutes ago' },
  { name: 'Alex P.', location: 'Sydney', partySize: 7, timeAgo: '18 minutes ago' },
  { name: 'Sofia C.', location: 'Barcelona', partySize: 6, timeAgo: '22 minutes ago' },
  { name: 'Mike T.', location: 'Boston', partySize: 4, timeAgo: '25 minutes ago' }
];

export const tours = [
  {
    id: 'main-tour',
    title: 'Hollywood Fame Tour',
    subtitle: 'The Ultimate All-Inclusive Hollywood Sightseeing Tour',
    price: 300,
    duration: 'Full Day',
    image: 'https://static.prod-images.emergentagent.com/jobs/0db38a4d-9eca-46f0-9975-4175ea5b16fd/images/e6a43cd2578cc65997669ad91d6d64fa3f1cac395ee3e2e0bc09c42190af9945.png',
    includes: [
      'Breakfast & Lunch Included',
      'Santa Monica Beach & Pier',
      'Warner Bros Studios Photo Stop',
      'Beverly Hills, Sunset Blvd & Rodeo Drive',
      'Celebrity Mansions & Hollywood Attractions',
      'Hollywood Blvd & Walk of Fame Sightseeing',
      'TCL Chinese Theatre (Hand Prints)',
      '2 Fabulous Views of Hollywood Sign',
      'Hotel Pickup from Hollywood Area'
    ],
    featured: true
  },
  {
    id: 'music-studio',
    title: 'Music Studio Tour Add-On',
    subtitle: 'Behind the Scenes of Hollywood Music Attractions',
    price: 250,
    duration: '3 Hours',
    image: 'https://images.unsplash.com/photo-1627928173650-fd1e0f2c24fc?auto=format&fit=crop&w=800&q=80',
    includes: [
      'Professional Recording Studio Tour',
      'Meet Music Industry Professionals',
      'See Where Hits Are Made',
      'Exclusive Studio Access',
      'Photo Opportunities'
    ],
    isAddon: true
  },
  {
    id: 'melrose-shopping',
    title: 'Melrose & Rodeo Drive Shopping',
    subtitle: 'Shop Like a Celebrity — Hollywood Attractions',
    price: 125,
    duration: '3 Hours',
    image: 'https://images.pexels.com/photos/19139509/pexels-photo-19139509.jpeg?auto=compress&cs=tinysrgb&w=1200',
    includes: [
      'Rodeo Drive Luxury Shopping',
      'Guided Melrose Avenue Shopping',
      'Boutique & Designer Stores',
      'Street Art Photo Stops',
      'Celebrity Shopping Hotspots',
      'Personal Shopping Tips'
    ],
    isAddon: true
  },
  {
    id: 'nightclub-tour',
    title: 'Hollywood Nightclub Hop',
    subtitle: 'Experience LA Nightlife — Hollywood Sightseeing After Dark',
    price: 130,
    duration: 'Evening',
    image: 'https://images.unsplash.com/photo-1566417713940-fe7c737a9ef2?auto=format&fit=crop&w=800&q=80',
    includes: [
      'VIP Entry to 3 Exclusive Clubs',
      'Skip-the-Line Access',
      'Complimentary Welcome Drink',
      'Professional Party Host',
      'Transportation Between Venues',
      'Late Night Return to Hotel'
    ],
    featured: true,
    badge: 'NEW',
    isAddon: true
  }
];

export const pickupLocations = [
  {
    area: 'Hollywood Blvd',
    hotels: [
      'Hollywood Roosevelt Hotel',
      'Loews Hollywood Hotel',
      'W Hollywood',
      'Hollywood Celebrity Hotel',
      'Magic Castle Hotel'
    ]
  },
  {
    area: 'Century City',
    hotels: [
      'InterContinental Los Angeles',
      'Fairmont Century Plaza',
      'JW Marriott LA Live',
      'Century Wilshire Hotel'
    ]
  },
  {
    area: 'Downtown LA',
    hotels: [
      'The Westin Bonaventure',
      'Millennium Biltmore Hotel',
      'Hotel Figueroa',
      'The Hoxton Downtown LA'
    ]
  },
  {
    area: 'Santa Monica',
    hotels: [
      'Shutters on the Beach',
      'Hotel Casa del Mar',
      'Fairmont Miramar',
      'Shore Hotel'
    ]
  }
];

export const testimonials = [
  {
    name: 'Jennifer W.',
    location: 'San Francisco',
    rating: 5,
    text: 'The best Hollywood sightseeing tour we\'ve ever done! Every Hollywood attraction was covered — Walk of Fame, Beverly Hills, the Hollywood Sign. Our guide was incredible and the all-inclusive lunch was amazing!',
    partySize: 6
  },
  {
    name: 'Michael B.',
    location: 'London, UK',
    rating: 5,
    text: 'Best Hollywood tour in LA! We saw every major Hollywood attraction — the Sign up close, walked the Walk of Fame, strolled Rodeo Drive, and the beach stop was perfect. Worth every penny of the sightseeing tour!',
    partySize: 4
  },
  {
    name: 'Lisa K.',
    location: 'Chicago',
    rating: 5,
    text: 'This Hollywood sightseeing tour was perfect for our group celebration! We hit every Hollywood attraction plus the music studio add-on was a once-in-a-lifetime experience. Highly recommend booking all the add-ons!',
    partySize: 8
  }
];

export const agendaItems = [
  {
    step: 1,
    title: 'Hotel Pickup & Breakfast',
    description: 'Morning pickup from your hotel. Enjoy complimentary gourmet breakfast as we begin your Hollywood sightseeing tour adventure.',
    time: '8:00 AM'
  },
  {
    step: 2,
    title: 'Santa Monica Beach & Pier',
    description: 'Arrive at the iconic Santa Monica Beach & Pier — one of LA\'s most popular Hollywood attractions. Walk the boardwalk and capture stunning Pacific Ocean photos.',
    time: '9:30 AM'
  },
  {
    step: 3,
    title: 'Warner Bros Studios',
    description: 'Exclusive photo opportunity at legendary Warner Bros Studios. See where Hollywood magic is made — a must-see Hollywood attraction.',
    time: '11:00 AM'
  },
  {
    step: 4,
    title: 'Gourmet Lunch Stop',
    description: 'Sit-down gourmet lunch at a local restaurant included with your Hollywood tour. Vegetarian and special dietary options available.',
    time: '12:30 PM'
  },
  {
    step: 5,
    title: 'Beverly Hills & Rodeo Drive',
    description: 'Cruise through legendary Beverly Hills on your Hollywood sightseeing tour. See celebrity mansions and shop on world-famous Rodeo Drive.',
    time: '2:00 PM'
  },
  {
    step: 6,
    title: 'Hollywood Walk of Fame Sightseeing',
    description: 'Walk among 2,700+ stars on the Hollywood Walk of Fame — Hollywood\'s #1 attraction. Visit TCL Chinese Theatre and celebrity handprints.',
    time: '3:30 PM'
  },
  {
    step: 7,
    title: 'Hollywood Sign Views',
    description: 'Two exclusive viewpoints for perfect Hollywood Sign photos — the most photographed Hollywood attraction. Capture memories that last forever.',
    time: '5:00 PM'
  },
  {
    step: 8,
    title: 'Return to Hotel',
    description: 'Comfortable return to your hotel after the most complete Hollywood sightseeing tour in Los Angeles.',
    time: '6:00 PM'
  }
];
